import { render, staticRenderFns } from "./Agendatuservicio.vue?vue&type=template&id=0a745032&"
import script from "./Agendatuservicio.vue?vue&type=script&lang=ts&"
export * from "./Agendatuservicio.vue?vue&type=script&lang=ts&"
import style0 from "./Agendatuservicio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports